import { Box } from '@material-ui/core';
import React, { LegacyRef } from 'react';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { SectionScheme } from '@/config/types';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useSectionContext } from '@/contexts/SectionContext/SectionContext';
import { useScreen } from '@/hooks/useScreen';

interface DynamicSectionProps {
  section: SectionScheme;
  isLastSection: boolean;
  sectionStartRef: LegacyRef<HTMLDivElement>;
}

export const DynamicSection = ({ section, isLastSection, sectionStartRef }: DynamicSectionProps) => {
  const { isSectionVisible, sectionKey } = useSectionContext();
  const {
    state: { sectionsVisible },
  } = usePageContext();
  const { isMobile } = useScreen();

  const sectionWatchersStyle = {
    top: 0,
    maxHeight: 'calc(100% - 50vh)',
    minHeight: '200px',
    position: 'absolute',
    height: '100%',
    // width: '50px', // uncomment to show sectionWatchers
    // border: '2px solid #f707',  // uncomment to show sectionWatchers
  } as React.CSSProperties;

  const invisiblePageContentStyle = {
    display: 'none',
    opacity: 0,
  };

  const visibleSectionIndex = sectionsVisible.indexOf(sectionKey) as number;

  const pageContentStyle = isSectionVisible === undefined ? invisiblePageContentStyle : {};

  if (isSectionVisible === false) {
    return null;
  }

  return (
    <section
      style={{
        ...pageContentStyle,
        position: 'relative',
        minHeight: isLastSection ? '65vh' : '130px',
        paddingBottom: isLastSection ? '20vh' : '0',
        boxSizing: 'border-box',
        marginBottom: isMobile ? '56px' : '70px',
      }}
    >
      <div
        id={section.textId ? `${section.textId.toLowerCase()}` : `section-${sectionKey}`}
        style={{
          position: 'relative',
          top: sectionKey === 0 ? '-13vh' : '-12vh',
        }}
      />
      {section.textId && (
        <Font
          variant={'h3'}
          key={`${sectionKey}-typo`}
          color={'title'}
          style={{ marginBottom: isMobile ? '40px' : '28px' }}
        >
          <Text tId={section.textId} key={`${sectionKey}-text`} />
        </Font>
      )}
      <div
        ref={sectionStartRef}
        data-visible-section-index={visibleSectionIndex !== -1 ? visibleSectionIndex : undefined}
        style={{
          ...sectionWatchersStyle,
          top: '0px',
        }}
      ></div>
      <Box>{section.module}</Box>
    </section>
  );
};
